import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorMessageComponent } from "./error-message.component";
import { RouterLink } from "@angular/router";

@NgModule({
  declarations: [
    ErrorMessageComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterLink,
  ]
})
export class TmErrorMessageModule{
}